export enum LogLevel {
    None = 0,
    Info = 1,
    Verbose = 2,
    Warn = 3,
    Error = 4
  }